import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs';
import { StorageHelper } from './helpers/StorageHelper';
import { BaseService } from './classes/BaseService';
import * as Bowser from "bowser";
import { environment } from '../environments/environment';

@Injectable()
export class CrashReportService extends BaseService{

  public apiUrl = "FrontendCrashReportService.php?";

  constructor(
    protected http: HttpClient,
  ) {
      super(http);
  }

  sendError(error: string[], stackTrace?: string, contextInfo?: any): Observable<Object> {

    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers: headers };
    const url = this.serverUrl + this.apiUrl;

    let message = "";

    // Add stack trace at the beginning for better visibility
    if (stackTrace) {
      message += "========== FULL STACK TRACE ==========\n";
      message += stackTrace;
      message += "\n========================================\n\n";
    }

    message += "-------- LOG HISTORY --------";

    //Error¸
    for (const err of error) {
      message += "\n" + err +  "\n";
    }

    message += "\n---------- LOG END ----------";

    //Timestamp
    const date: string = new Date().toString();
    message += "\n" + date;

    // App Version
    message += "\n\n========== APPLICATION INFO ==========";
    const versionMajor = environment.versionMajor || 'unknown';
    const versionMinor = environment.versionMinor || 'unknown';
    const versionPatch = environment.versionPatch || 'unknown';
    const appVersion = "v." + versionMajor + "." + versionMinor + "." + versionPatch;
    message += "\nApp Version: " + appVersion;
    message += "\nBuild Number: " + versionPatch;

    //User infos
    message += "\n\n========== USER INFO ==========";
    message += "\nUsername: " + StorageHelper.getInstance().get(StorageHelper.keys.username);
    message += "\nSessionToken: " + StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);

    //Additional Browser infos
    message += "\n\n========== BROWSER INFO ==========";
    const bowser = Bowser.getParser(navigator.userAgent);
    message += "\nCookies Enabled: " + navigator.cookieEnabled;
    message += "\nBrowser: " + bowser.getBrowserName() + " " + bowser.getBrowserVersion();
    message += "\nOS: " + bowser.getOSName() + " " + bowser.getOSVersion();
    message += "\nPlatform: " + bowser.getPlatformType();
    message += "\nBrowser Language: " + navigator.language;
    message += "\nUser Agent: " + navigator.userAgent;

    // Context Information
    if (contextInfo && Object.keys(contextInfo).length > 0) {
      message += "\n\n========== CONTEXT INFORMATION ==========";

      // URL Information
      if (contextInfo.url) {
        message += "\n--- URL Information ---";
        message += "\nFull URL: " + contextInfo.url.href;
        message += "\nPathname: " + contextInfo.url.pathname;
        message += "\nSearch Params: " + (contextInfo.url.search || "none");
        message += "\nHash: " + (contextInfo.url.hash || "none");
        message += "\nOrigin: " + contextInfo.url.origin;
      }

      // Router State
      if (contextInfo.routerUrl) {
        message += "\n--- Router State ---";
        message += "\nRouter URL: " + contextInfo.routerUrl;
      }

      // Referrer
      if (contextInfo.referrer) {
        message += "\n--- Navigation ---";
        message += "\nReferrer: " + contextInfo.referrer;
      }

      // Application State
      if (contextInfo.appState) {
        message += "\n--- Application State ---";
        if (typeof contextInfo.appState === 'object') {
          message += "\nCountry: " + (contextInfo.appState.country || "unknown");
          message += "\nStore: " + (contextInfo.appState.store || "unknown");
          message += "\nMedia Type: " + (contextInfo.appState.mediaType || "unknown");
        } else {
          message += "\n" + contextInfo.appState;
        }
      }

      // Screen/Viewport Information
      if (contextInfo.screen) {
        message += "\n--- Screen Information ---";
        message += "\nScreen Resolution: " + contextInfo.screen.width + "x" + contextInfo.screen.height;
        message += "\nAvailable Size: " + contextInfo.screen.availWidth + "x" + contextInfo.screen.availHeight;
        message += "\nColor Depth: " + contextInfo.screen.colorDepth + " bits";
        message += "\nPixel Depth: " + contextInfo.screen.pixelDepth + " bits";
      }

      if (contextInfo.viewport) {
        message += "\n--- Viewport Information ---";
        message += "\nInner Size: " + contextInfo.viewport.innerWidth + "x" + contextInfo.viewport.innerHeight;
        message += "\nOuter Size: " + contextInfo.viewport.outerWidth + "x" + contextInfo.viewport.outerHeight;
      }

      // Network Status
      if (contextInfo.networkStatus) {
        message += "\n--- Network Status ---";
        message += "\nOnline: " + contextInfo.networkStatus.onLine;
        if (contextInfo.networkStatus.connection && typeof contextInfo.networkStatus.connection === 'object') {
          message += "\nConnection Type: " + contextInfo.networkStatus.connection.effectiveType;
          message += "\nDownlink: " + contextInfo.networkStatus.connection.downlink + " Mbps";
          message += "\nRTT: " + contextInfo.networkStatus.connection.rtt + " ms";
        }
      }

      // Performance Information
      if (contextInfo.performance && contextInfo.performance.memory) {
        message += "\n--- Performance Information ---";
        message += "\nUsed JS Heap: " + contextInfo.performance.memory.usedJSHeapSize;
        message += "\nTotal JS Heap: " + contextInfo.performance.memory.totalJSHeapSize;
        message += "\nJS Heap Limit: " + contextInfo.performance.memory.jsHeapSizeLimit;
      }

      // Error Timestamp
      if (contextInfo.errorTimestamp) {
        message += "\n--- Error Timestamp ---";
        message += "\nISO: " + contextInfo.errorTimestamp.iso;
        message += "\nTimestamp: " + contextInfo.errorTimestamp.timestamp;
        message += "\nTimezone: " + contextInfo.errorTimestamp.timezone;
      }

      if (contextInfo.collectionError) {
        message += "\n--- Context Collection Error ---";
        message += "\n" + contextInfo.collectionError;
      }
    }

    message += "\n\n========================================\n";

    return this.post(url, "message=" + encodeURIComponent(message));
  }

}
